import React, { useEffect, useRef, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import sanityClient from '../utils/sanityClient';

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;

const MapSection = () => {
  const mapContainer = useRef(null);
  const mapRef = useRef(null);
  const [coordinates, setCoordinates] = useState([]);

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        const properties = await sanityClient.fetch(`*[_type == "property" && defined(location)]{
          _id,
          title,
          location,
          price,
          bedrooms,
          bathrooms,
          propertyType,
          images[] {asset->{url}}
        }`);

        const geocoded = await Promise.all(
          properties.map(async (property) => {
            const response = await fetch(
              `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(property.location)}.json?access_token=${mapboxgl.accessToken}`
            );
            const data = await response.json();
            const coords = data.features?.[0]?.center;
            return coords ? { ...property, coords } : null;
          })
        );

        setCoordinates(geocoded.filter(Boolean));
      } catch (error) {
        console.error('Error loading property coordinates:', error);
      }
    };

    fetchProperties();
  }, []);

  useEffect(() => {
    if (mapRef.current || !mapContainer.current) return;

    mapRef.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/mapbox/dark-v10', // Dark theme for the map
      center: [-0.1276, 51.5074], // London, UK coordinates
      zoom: 10,
    });
  }, []);

  useEffect(() => {
    if (!mapRef.current) return;

    coordinates.forEach((property) => {
      // Create a custom house marker with SVG icon
      const el = document.createElement('div');
      el.style.width = '32px';
      el.style.height = '32px';
      el.style.display = 'flex';
      el.style.alignItems = 'center';
      el.style.justifyContent = 'center';
      el.style.background = 'rgba(104, 159, 56, 0.9)';
      el.style.borderRadius = '50%';
      el.style.border = '2px solid #ffffff';
      el.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.3)';
      el.style.cursor = 'pointer';
      
      // Add SVG house icon
      el.innerHTML = `
        <svg width="18" height="18" viewBox="0 0 24 24" fill="white">
          <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
        </svg>
      `;

      new mapboxgl.Marker(el)
        .setLngLat(property.coords)
        .addTo(mapRef.current);
    });
  }, [coordinates]);

  return (
    <div style={{ padding: '2rem 1rem' }}>
      <h2 style={{ 
        padding: '1rem', 
        textAlign: 'center',
        fontSize: '2rem',
        marginBottom: '1rem'
      }}>
        Map View
      </h2>
      <div
        ref={mapContainer}
        style={{ 
          height: '400px', 
          width: '100%', 
          borderRadius: '12px', 
          marginBottom: '2rem',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)'
        }}
      />
      
      <style>{`
        @media (max-width: 768px) {
          .mapboxgl-map {
            height: 300px !important;
          }
        }
        
        @media (max-width: 480px) {
          .mapboxgl-map {
            height: 250px !important;
          }
        }
      `}</style>
    </div>
  );
};

export default MapSection;
